/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Session_AddInputs */

const th_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่มเซสชัน`)
};

const en_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a session`)
};

const ja_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セッションを追加`)
};

const zh_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加课程`)
};

const es_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir una sesión`)
};

const pt_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar uma sessão`)
};

const id_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah sesi`)
};

const fr_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une séance`)
};

const tl_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magdagdag ng sesyon`)
};

const vi_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm buổi`)
};

const ko_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세션 추가`)
};

const de_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheit hinzufügen`)
};

const ru_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить занятие`)
};

const tr_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oturum ekle`)
};

const it_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi sessione`)
};

const pl_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj zajęcia`)
};

const uk_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Додати заняття`)
};

const hi_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सत्र जोड़ें`)
};

const ar_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إضافة حصة`)
};

const ms_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah sesi`)
};

const bn_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সেশন যোগ করুন`)
};

const zh_tw2_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增課程`)
};

const zh_hk2_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增課節`)
};

const ur_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سیشن شامل کریں`)
};

const fa_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افزودن جلسه`)
};

const sw_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeza kipindi`)
};

const nl_event_session_add = /** @type {(inputs: Event_Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessie toevoegen`)
};

/**
* | output |
* | --- |
* | "Add a session" |
*
* @param {Event_Session_AddInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_session_add = /** @type {((inputs?: Event_Session_AddInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Session_AddInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_session_add(inputs)
	if (locale === "ja") return ja_event_session_add(inputs)
	if (locale === "zh") return zh_event_session_add(inputs)
	if (locale === "es") return es_event_session_add(inputs)
	if (locale === "pt") return pt_event_session_add(inputs)
	if (locale === "id") return id_event_session_add(inputs)
	if (locale === "fr") return fr_event_session_add(inputs)
	if (locale === "tl") return tl_event_session_add(inputs)
	if (locale === "vi") return vi_event_session_add(inputs)
	if (locale === "ko") return ko_event_session_add(inputs)
	if (locale === "de") return de_event_session_add(inputs)
	if (locale === "ru") return ru_event_session_add(inputs)
	if (locale === "tr") return tr_event_session_add(inputs)
	if (locale === "it") return it_event_session_add(inputs)
	if (locale === "pl") return pl_event_session_add(inputs)
	if (locale === "uk") return uk_event_session_add(inputs)
	if (locale === "hi") return hi_event_session_add(inputs)
	if (locale === "ar") return ar_event_session_add(inputs)
	if (locale === "ms") return ms_event_session_add(inputs)
	if (locale === "bn") return bn_event_session_add(inputs)
	if (locale === "zh-TW") return zh_tw2_event_session_add(inputs)
	if (locale === "zh-HK") return zh_hk2_event_session_add(inputs)
	if (locale === "ur") return ur_event_session_add(inputs)
	if (locale === "fa") return fa_event_session_add(inputs)
	if (locale === "sw") return sw_event_session_add(inputs)
	if (locale === "nl") return nl_event_session_add(inputs)
	return en_event_session_add(inputs)
});